import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { Link } from 'react-router-dom'

import styles from "./AboutProposal.module.css";

function AboutProposalSection() {
    return (
        <Row className={styles.ContentContainer}>
            <Col className="d-flex align-items-center">
                <div>
                    <div className={styles.makeProposalTitle}>About this Proposal</div>
                    <div className={styles.makeProposalSubtext}>With so many experts on climate change here at Imperial, many people ask us what they personally can do about it? And how does this fit into the bigger picture?</div>
                    <br></br>
                    <div className={styles.makeProposalSubtext}>We spoke to our scientists at the Grantham Institute and drew up a list of the most achievable ways you personally can make a difference. While individuals alone may not be able to make drastic emissions cuts that limit climate change to acceptable levels, personal action is essential to raise the importance of issues to policymakers and businesses.</div>
                    <br></br>
                    <div className={styles.makeProposalSubtext}>Using your voice as a consumer, a customer, a member of the electorate and an active citizen, will lead to changes on a much grander scale.</div>
                    <br></br>
                    <div className={styles.makeProposalSubtext}>Tell your Member of Parliament, local councillors and city mayors that you think action on climate change is important. A prosperous future for the United Kingdom depends on their decisions about the environment, green spaces, roads, cycling infrastructure, waste and recycling, air quality and energy efficient homes. Ultimately, steps to reduce carbon emissions will have a positive impact on other local issues, like improving air quality and public health, creating jobs and reducing inequality.</div>
                    <br></br>
                    <div className={styles.makeProposalSubtext}>Vote for us to make a difference NOW!</div>
                </div>
            </Col>
        </Row>
    );
}

export default AboutProposalSection;